/* External */
import { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Other */
import { getJsonImage } from 'src/theme/images';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import { getAllowedContentOption } from '../../utils/profiles';

/* Assets */
import chevronRight from '../../assets/svg/chevron-right.svg';

/* Style */
import './FocusableEditAllowContentProfile.scss';

function EditAllowContentProfile({
  className,
  focused,
  isMainProfile,
  userProfilesAgeRating,
  allowContentProfile,
}) {
  const [allowedContentOption, setAllowedContentOption] = useState('');

  useEffect(() => {
    setAllowedContentOption(
      getAllowedContentOption(
        userProfilesAgeRating?.ageRating ?? allowContentProfile,
      ),
    );
  }, [userProfilesAgeRating, allowContentProfile]);

  return (
    <div className={`dtv-html5-c-profile-edit-allow-content ${className} ${
      focused ? 'dtv-html5-c-profile-edit-allow-content--focused' : ''
    }`}
    >
      <div className="dtv-html5-c-profile-edit-allow-content_label-profile">
        <p>
          <FormattedMessage id="profiles.parentalControl.content.allow" />
        </p>
      </div>
      <div className="dtv-html5-c-profile-edit-allow-content_rating-profile">
        {isMainProfile
          ? (
            <div className="dtv-html5-c-profile-edit-allow-content_rating-profile--disable-content">
              <FormattedMessage id="profiles.parentalControl.all.contents.allowed" />
            </div>
          ) : (
            <>
              <div>
                {allowedContentOption || <FormattedMessage id="profiles.parentalControl.all.contents.allowed" />}
              </div>
              <img src={getJsonImage('chevron-left') || chevronRight} alt="Chevron Right" />
            </>
          )}
      </div>
    </div>
  );
}

EditAllowContentProfile.defaultProps = {
  className: '',
  focused: false,
  isMainProfile: false,
  userProfilesAgeRating: '',
  allowContentProfile: '',
};

EditAllowContentProfile.propTypes = {
  className: PropTypes.string,
  focused: PropTypes.bool,
  isMainProfile: PropTypes.bool,
  userProfilesAgeRating: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      ageRating: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    }),
  ]),
  allowContentProfile: PropTypes.string,
};

export default memo(withInteractiveFocusable()(memo(EditAllowContentProfile)));
